/* eslint-disable import/no-named-as-default-member */
import { getCustomer } from "../../../../../util/user";
import TOKEN_UTIL from "../../../../../util/token.customerAppSettings/scanline";

const EMPTY_OBJECT = {};

export const initialState = {
	customer: getCustomer(),
	analysisPageCustomer: undefined,
	customerSettingsSource: EMPTY_OBJECT, // Aegion User Only, to be pulled from cloud and referenced only when an Aegion User changes the customer dropdown.
	isLoadingCustomerSettingsSource: false,
	isLoadedCustomerSettingsSource: getCustomer() !== 'Aegion',

	settings: {
		enableActionPlan: TOKEN_UTIL.hasSettingEnableActionPlan(),
		enableClosureReport: TOKEN_UTIL.hasSettingEnableClosureReport(),

		enableLinesListCardsView: TOKEN_UTIL.hasSettingEnableLinesListCardsView(),
		enableLinesListTableView: TOKEN_UTIL.hasSettingEnableLinesListTableView(),
		enableMyProjects: TOKEN_UTIL.hasSettingEnableMyProjects(),

		enableReports: TOKEN_UTIL.hasSettingEnableReports(),
		enableReportListActionPlanAndClosureV1: TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV1(),
		enableReportListActionPlanAndClosureV2: TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV2(),
		enableReportPercentPassing: TOKEN_UTIL.hasSettingEnableReportPercentPassing(),
		enableReportTotalMiles: TOKEN_UTIL.hasSettingEnableReportTotalMiles(),

		enableCustomerCreatedJobs: TOKEN_UTIL.hasSettingEnableCustomerCreatedJobs(),
		defaultUploadsToSearchable: TOKEN_UTIL.hasSettingDefaultUploadsToSearchable(),

		enableSharedStateForAnalysisAndReports: TOKEN_UTIL.hasSettingEnableSharedStateForAnalysisAndReports(),
		autoRemoveIliData: TOKEN_UTIL.hasSettingAutoRemoveIliData(),
		enablePsqlIliData: TOKEN_UTIL.hasSettingEnablePsqlIliData(),
		enableTempUploadAutoRemove: TOKEN_UTIL.hasSettingEnableTempUploadAutoRemove(),
		enablePersistLinkedSurveys: TOKEN_UTIL.hasSettingEnablePersistLinkedSurveys(),
		featureClosureCopyActionPlan: TOKEN_UTIL.hasSettingFeatureClosureCopyActionPlan(),
	},
};

export default initialState;
